import { Component, EventEmitter, Input, Output, OnInit, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-monthly-calendar',
  templateUrl: './monthly-calendar.component.html',
  styleUrls: ['./monthly-calendar.component.scss'],
})
export class MonthlyCalendarComponent implements OnInit {
  allYears: number[] = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - (5 - i));
  months: string[] = [];
  leftYear: number|any = this.allYears[0];
  rightYear: number|any = this.allYears[5]; // Initialize right year
  leftMonths: string[] = [];
  rightMonths: string[] = [];
  // leftallYears: number[]=[];
  // rightallYears: number[]=[];
  headerName:any='Date Selection'

  selectedStartMonth!: string | any;
  selectedEndMonth!: string | any;

  minMonth!: string ; // Minimum month
  maxMonth!: string ; // Maximum month

  @Input("selectedData") selectedData: any;
  @Input("DateConfig") DateConfig: any;
  @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();

  minYear!: number; // Global minimum year
  maxYear!: number; // Global maximum year

  startYear: number|any = 2023; // Default start year
  endYear: number|any = new Date().getFullYear(); // Default end year

  constructor(private filterService :FilterService) {}
  
  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selectedData']?.currentValue!=changes['selectedData']?.previousValue) {
      this.months = this.generateMonths(this.allYears);
      // this.splitMonthsIntoPanels();
      // this.rightYear =this.startYear
      // this.leftYear = this.endYear
    
      this.selectedStartMonth= moment(this.selectedData.from_date).format('MMM YYYY')
      this.selectedEndMonth= moment(this.selectedData.to_date).format('MMM YYYY')
      this.minYear   = Number(moment(this.DateConfig.option.minDate).format('YYYY'));
      this.maxYear   = Number(moment(this.DateConfig.option.maxDate).format('YYYY'));
      this.startYear = Number(moment(this.DateConfig.option.minDate).format('YYYY'));
      this.endYear   = Number(moment(this.DateConfig.option.maxDate).format('YYYY'));
      this.leftYear =  Number(moment(this.DateConfig.option.minDate).format('YYYY'));
      this.rightYear = Number(moment(this.DateConfig.option.maxDate).format('YYYY'));
      this.minMonth =  moment(this.DateConfig.option.minDate).format('MMM YYYY')
      this.maxMonth =  moment(this.DateConfig.option.maxDate).format('MMM YYYY'); // Maximum month
      this.updateLeftMonths(this.leftYear)
      this.updateRightMonths(this.rightYear)
    }
  }
  
  /**
   * Dynamically calculate disabled years for the start year selector.
   */
  get disabledYearsForStartSelector(): number[] {
    const disabledYears = [];
    // Disable all years after the endYear
    for (let year = this.endYear + 1; year <= this.maxYear; year++) {
      disabledYears.push(year);
    }
    return disabledYears;
  }

  /**
   * Dynamically calculate disabled years for the end year selector.
   */
   get disabledYearsForEndSelector(): number[] {
    const disabledYears = [];
  
    // Disable all years before the startYear
    for (let year = this.minYear; year < this.startYear; year++) {
      disabledYears.push(year);
    }
  
    // // Disable all years after the current year
    // const currentYear = new Date().getFullYear();
    // for (let year = currentYear ; year <= this.maxYear; year++) {
    //   disabledYears.push(year);
    // }
    return disabledYears;
  }
  /**
   * Handle start year selection.
   */
  onStartYearSelected(year: number) {
    if (year > this.endYear) {
      // If the selected start year exceeds the current end year, adjust the end year
      this.endYear = year;
    }
    this.startYear = year;
    this.leftYear = this.startYear
    this.updateLeftMonths( this.startYear)
  }

  /**
   * Handle end year selection.
   */
  onEndYearSelected(year: number) {
    if (year < this.startYear) {
      // If the selected end year is less than the current start year, adjust the start year
      this.startYear = year;
    }
    this.endYear = year;
    this.rightYear = this.endYear
    this.updateRightMonths(this.endYear)
  }
  
  
 
  updateLeftMonths(year:any) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    this.leftMonths = monthNames.map(m => `${m} ${year}`);
  }

  updateRightMonths(year:any) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    this.rightMonths = monthNames.map(m => `${m} ${year}`);
  }
  generateMonths(years: number[]): string[] {
    const monthNames = [
      { shortName: 'Jan', fullName: 'January' },
      { shortName: 'Feb', fullName: 'February' },
      { shortName: 'Mar', fullName: 'March' },
      { shortName: 'Apr', fullName: 'April' },
      { shortName: 'May', fullName: 'May' },
      { shortName: 'Jun', fullName: 'June' },
      { shortName: 'Jul', fullName: 'July' },
      { shortName: 'Aug', fullName: 'August' },
      { shortName: 'Sep', fullName: 'September' },
      { shortName: 'Oct', fullName: 'October' },
      { shortName: 'Nov', fullName: 'November' },
      { shortName: 'Dec', fullName: 'December' },
    ];
    return years.flatMap(year => monthNames.map((m:any) => `${m.shortName} ${year}`));
  }

  splitMonthsIntoPanels() {
    // debugger
    const midIndex    = Math.ceil(this.months.length / 2);
    this.leftMonths   = this.months.slice(0,  12);
    this.rightMonths  = this.months.slice( this.months.length-12);
    // this.leftallYears = this.allYears.slice(0,  3);
    // this.rightallYears=this.allYears.slice(this.allYears.length-3);
  }

// Handle selectMonth selection logic
selectMonth(month: string, type: string) {
  // Convert the selected month string to a Date object for comparison
  const monthDate = new Date(month);

  if (type === 'start') {
    // Set the selected start month
    this.selectedStartMonth = month;

    // Ensure that the end month is not before the newly selected start month
    if (this.selectedEndMonth) {
      const endMonthDate = new Date(this.selectedEndMonth);
      if (monthDate > endMonthDate) {
        // Reset the end month if it's before the new start month
        this.selectedEndMonth = null;
      }
    }
  } else if (type === 'end') {
    // Set the selected end month
    if (!this.selectedStartMonth) {
      // If no start month is selected, set the start month instead
      this.selectedStartMonth = month;
    } else {
      const startMonthDate = new Date(this.selectedStartMonth);
      if (monthDate >= startMonthDate) {
        // Only set the end month if it's on or after the start month
        this.selectedEndMonth = month;
      } else {
        // If the selected month is before the start month, reset both selections
        this.selectedStartMonth = null;
        this.selectedEndMonth = month;
      }
    }
  }

  // Optional: You can add additional checks here, such as disabling invalid months
}
// selectMonth(month: string,type:string) {
//   if(type=='start'){
//   this.selectedStartMonth = month}
//   if(type=='end'){
//   this.selectedEndMonth = month}
//   // if (this.isDisabled(month)) return;

//   // // Convert month strings to Date objects for proper comparison
//   // const monthDate = new Date(month);
//   // const startMonthDate = this.selectedStartMonth ? new Date(this.selectedStartMonth) : null;

//   // // If no start month or end month already selected, select the start month
//   // if (!startMonthDate || this.selectedEndMonth) {
//   //   this.selectedStartMonth = month;
//   //   this.selectedEndMonth = null;
//   // } else if (monthDate > startMonthDate) {
//   //   // If the selected month is after the start month, set it as the end month
//   //   this.selectedEndMonth = month;
//   // } else {
//   //   // If the selected month is before the start month, reset the selection
//   //   this.selectedStartMonth = month;
//   //   this.selectedEndMonth = null;
//   // }
// }
  isSelected(month: string): boolean {
    return this.selectedStartMonth === month || this.selectedEndMonth === month;
  }

  isInRange(month: string): boolean {
    if (!this.selectedStartMonth || !this.selectedEndMonth) return false;
    const startIdx = this.months.indexOf(this.selectedStartMonth);
    const endIdx = this.months.indexOf(this.selectedEndMonth);
    const currIdx = this.months.indexOf(month);
    return currIdx >= startIdx && currIdx <= endIdx;
  }

  isDisabled(month: string): boolean {
    const monthIndex = this.months.indexOf(month);
    const minIndex = this.months.indexOf(this.minMonth);
    const maxIndex = this.months.indexOf(this.maxMonth);
    return monthIndex < minIndex || monthIndex > maxIndex;
  }

  getMonthStartDate(month: string): Date {
    const [m, year] :any= month.split(' ');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthIndex = monthNames.indexOf(m);
    return new Date(year, monthIndex, 1);
  }

  getMonthEndDate(month: string): Date {
    const [m, year]:any = month.split(' ');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthIndex = monthNames.indexOf(m);
    return new Date(year, monthIndex + 1, 0); // 0 gets the last day of the previous month
  }

  clearDates() {
    this.selectedStartMonth = null;
    this.selectedEndMonth = null;
  }

  applyDates() {

     let monthendSelected:any =  moment(new Date()).endOf('month').toDate() 
    if(moment(monthendSelected).format('DD-MM-YYYY') === moment(this.getMonthEndDate(this.selectedEndMonth)).format('DD-MM-YYYY')) {
           this.filterService.bufferSlider.next(false);
           
          } else {
          this.filterService.bufferSlider.next(true);
           
      }
        
    if (this.selectedStartMonth && this.selectedEndMonth) {
      this.applyFilter.emit({
        from_date: this.getMonthStartDate(this.selectedStartMonth),
        to_date: this.getMonthEndDate(this.selectedEndMonth),
      });
    } else {
      alert('Please select both start and end months.');
    }
    //menu close
  document.getElementById("du-page")?.click()
  }
} 